<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'OrderControl'
};
</script>

<style lang="less" scoped></style>